module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Welcome to eAgent","message":"Please login to continue."},"es":{"title":"Bienvenido a eAgent","message":"Por favor inicie sesión para continuar."}}')
  delete Component.options._Ctor
}
